export default "__VITE_ASSET__X$icdlNY__"